module.exports = __webpack_public_path__ + "img/overview_icon_white.3acb9aab.svg";